<script>
  import Filters      from './filters/filters.svelte';
  import DriverPicker from './filters/optional-filters/driver-filter/driver-picker/driver-picker.svelte';
  import Footer       from './footer/footer.svelte';
  import Help         from './help/help.svelte';
  import Results      from './results/results.svelte';
</script>

<style>
  /* https://css-tricks.com/box-sizing/#aa-universal-box-sizing-with-inheritance */
  :global(*),
  :global(*:before),
  :global(*:after) {
    box-sizing: inherit;
  }

  :global(html) {
    box-sizing: border-box;
    /* This is set on the html element instead of body because rem units are relative
       to the root html element */
    font-size: 14px;
  }

  :global(body) {
    color: #333;
    font-family: -apple-system,
                 BlinkMacSystemFont,
                 "Segoe UI",
                 Roboto,
                 Oxygen-Sans,
                 Ubuntu,
                 Cantarell,
                 "Helvetica Neue",
                 sans-serif;
    margin: 0;
    padding: 0;
  }

  @media (min-width: 1244px) {
    :global(body) {
      background-attachment: fixed;
      background-image: url('img/Mushroom_Cup_logo_repeat.png');
    }
  }

  :global(a) {
    color: #0c78ca;
    cursor: pointer;
  }

  :global(button) {
    cursor: pointer;
    font: inherit;
  }

  :global(h2) {
    font-weight: normal;
  }

  :global(input[type="checkbox"]) {
    cursor: pointer;
  }

  :global(label) {
    cursor: pointer;
  }

  :global(select) {
      cursor: pointer;
  }

  :global(.btn-text-only) {
    background: none;
    border: none;
    color: #0c78ca;
    margin: 0;
    padding: 0;
  }

  :global(.clearfix) {
    clear: both;
  }

  /* used in Welcome and HelpButton */
  :global(.help-icon) {
    background-image: url('favicon.ico');
    border: none;
    display: inline-block;
    height: 16px;
    margin: 0;
    padding: 0;
    vertical-align: middle;
    width: 16px;
  }

  /* used in DriverSizeFilter and ResultsTable */
  :global(.size-large)  { background-color: mistyrose; }
  :global(.size-medium) { background-color: honeydew; }
  :global(.size-small)  { background-color: #cff; }

  /* END globals **************************************************************/

  #app {
    background: #fff;
    margin: 0 auto;
    max-width: 1194px;
    padding: 20px;
  }

  h1 {
    display: inline-block;
    margin: 0;
    vertical-align: top;
    width: 400px;
  }

  h1 p {
    font-size: 14px;
    margin: -14px 0 0 52px;
    text-transform: uppercase;
  }

  #help-outer {
    width: 700px;
  }

  @media only screen and (max-width: 1159px) {
    #help-outer {
      margin-top: 20px;
    }
  }

  @media only screen and (min-width: 1160px) {
    #help-outer {
      float: right;
    }
  }
</style>

<template lang="pug" src="./app.pug"></template>
